import script from "./themeSelectionPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./themeSelectionPopup.vue?vue&type=script&setup=true&lang=js"

import "./themeSelectionPopup.vue?vue&type=style&index=0&id=33f5b97c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33f5b97c"]])

export default __exports__